// A modal dialog on the native <dialog> element: focus moves in, Escape closes, and the page
// behind can't be reached until it does.

import { useEffect, useRef } from "react";

export function Modal({ titleId, describedBy, onClose, children }: {
  titleId: string;
  describedBy?: string;
  onClose: () => void;
  children: React.ReactNode;
}) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = ref.current;
    if (dialog && !dialog.open) dialog.showModal();
    return () => dialog?.close();
  }, []);

  return (
    <dialog
      ref={ref}
      className="cv-modal"
      aria-labelledby={titleId}
      aria-describedby={describedBy}
      onCancel={(event) => { event.preventDefault(); onClose(); }}
      style={{ border: 0, color: "var(--ink)" }}
    >
      {children}
    </dialog>
  );
}
